import { type TFunction } from "i18next";

import { ProductResourceStatus } from "@fitness-app/data-models/entities/ProductResource";

export const productResourceStatusOptions = (t: TFunction) => [
  {
    label: t(`common:productResourceStatus.${ProductResourceStatus.DRAFT.toLowerCase()}`),
    value: ProductResourceStatus.DRAFT,
  },
  {
    label: t(`common:productResourceStatus.${ProductResourceStatus.AVAILABLE.toLowerCase()}`),
    value: ProductResourceStatus.AVAILABLE,
  },
  {
    // TRE-1962 — between a draft and a published material: visible to the clients carrying the
    // PostHog `hasAccessToInReviewResources` flag, nobody else.
    label: t(`common:productResourceStatus.${ProductResourceStatus.IN_REVIEW.toLowerCase()}`),
    value: ProductResourceStatus.IN_REVIEW,
  },
  {
    label: t(`common:productResourceStatus.${ProductResourceStatus.UNAVAILABLE.toLowerCase()}`),
    value: ProductResourceStatus.UNAVAILABLE,
  },
];
